import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CartsPage, useAdminCartStore } from '@features/admin/carts';

const adminCartsSearchSchema = z.object({
  q: z.string().optional(),
  organizationId: z.coerce.number().optional(),
  // Jen kosiky bez zmeny dele nez X dni (opustene).
  inactiveDays: z.coerce.number().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminCartsSearch = z.infer<typeof adminCartsSearchSchema>;

export const Route = createFileRoute('/admin/carts/')({
  validateSearch: search => adminCartsSearchSchema.parse(search),
  component: CartsPage,
  beforeLoad: ctx => {
    const { q, organizationId, inactiveDays, page, size } = ctx.search;
    useAdminCartStore.getState().loadCarts({ q, organizationId, inactiveDays, page: page || 1, size: size || 20 });
  },
});
